{
  "title": "Tuning",
  "lead": "The changes admin builds of this pack's game apply: started with --tuning-url and --tuning-key (Settings has the keys), the game fetches them at boot and at each floor. Values are the game's own text.",
  "revision": "Revision {{revision}}",
  "updated": "saved {{at}}",
  "values": "Tunable values",
  "noSchema": "No tunable list yet",
  "noSchemaHint": "Publish the Hero Sheet with the game's tunable schema (make prod-publish-workshop tunables=… in delve-backend), or connect the live link and read the game's schema.",
  "search": "Search",
  "category": "Category",
  "allCategories": "Every category",
  "changedOnly": "Changed only ({{count}})",
  "sendLive": "Send each change to the game",
  "tunable": "Tunable",
  "value": "Value",
  "default": "Default",
  "range": "Range",
  "reset": "Reset",
  "resetOne": "Reset {{name}}",
  "noMatch": "No tunable matches.",
  "unsavedDot": "Not saved yet",
  "changedDot": "Changed from the default",
  "restart": "applies at the next {{when}}",
  "expected": "Expected {{what}}.",
  "outOfRange": "Outside the range: the game clamps it.",
  "more": "Show more ({{count}})",
  "save": "Save changes ({{count}})",
  "saved": "Saved: revision {{revision}}. Admin builds pick it up at their next floor.",
  "discard": "Discard edits",
  "resetAll": "Reset everything",
  "applyToGame": "Apply to the game",
  "applied": "The game applied every value.",
  "applyMissed": "The game could not apply: {{ids}}",
  "takeFromGame": "Take the game's changes",
  "taken": "{{count}} values taken from the game: save to keep them.",
  "readSchema": "Read the game's schema",
  "schemaRead": "{{count}} tunables read from the game.",
  "integrate": "Integrate into the assets",
  "integrateAsked": "Asked the Unity editor's game to write {{count}} values into the assets.",
  "profiles": "Profiles",
  "profilesHint": "Saved sets of values. Load one to edit it, or use it as the live changes.",
  "valuesCount_one": "{{count}} value",
  "valuesCount_other": "{{count}} values",
  "load": "Load",
  "useLive": "Use",
  "deleteProfile": "Delete {{name}}",
  "confirmDelete": "Delete the profile {{name}}?",
  "noProfiles": "No profile yet.",
  "profileName": "Name",
  "saveAsProfile": "Save as profile",
  "profileSaved": "Profile {{name}} saved.",
  "profileApplied": "{{name}} is now the live changes.",
  "integrations": "Integrations",
  "integrationsHint": "The Unity editor's game (started with a game key) writes them into the project's assets, then marks them done.",
  "done": "done",
  "waiting": "waiting for the editor",
  "noIntegrations": "None asked yet."
}
